import { BundleInfo, BundleId, CapacitorUpdater } from "@capgo/capacitor-updater";
import { sportTitle } from "../admin_actions/apiUtils";
import { useModalStore } from "@/store/modalStore";
import { isMobileApp } from "./mobileAppServices";
import UpdateAppPopUp from "@/components/MobileAppComponents/UpdateAppPopUp.vue";
import { useUserDataStore } from "@/store/userDataStore";
import { App } from '@capacitor/app'



/**
 * Checks for updates and applies them if available.
 */
export async function checkForUpdates(): Promise<void> {

  if (!isMobileApp()) {
    return;
  }

  App.addListener('appStateChange', async (state) => {
    if (state.isActive) {
      // Check for updates when the app becomes active
      await checkForUpdatesAfterFetch();
    }
  });

  CapacitorUpdater.addListener('downloadComplete', async (event) => {
    console.log("Update downloaded, showing modal...");
    await DisplayUpdatePopUp(event.bundle);
  });

  
}

async function DisplayUpdatePopUp(bundle: BundleInfo) {
  const modalStore = useModalStore();
  modalStore.openModal({
    title: 'Update Available!',
    description: '',
    component: UpdateAppPopUp,
    props: {
      version: bundle,
    },
  });
}

async function checkForUpdatesAfterFetch() {

  const userDataStore = useUserDataStore();

  try {
    //get the latest version from the intitialise call
    const latestVersion = userDataStore.currentAppVersion;

    console.log(`Latest version available: ${latestVersion}`);
    // Check for updates using LiveUpdate
    // see what the current version is from the preferences api
    const currentVersion = await CapacitorUpdater.current();
    console.log(`Current app version: ${currentVersion.bundle.version}`);
    if (latestVersion !== null && currentVersion.bundle.version !== latestVersion) {

      console.log("New update available, downloading update...");
      
      // Download the update
      const version = await CapacitorUpdater.download({
        version: latestVersion,
        url: `https://services.leveltech.io/app_updates/release-${sportTitle.value}-${latestVersion}.zip`,
      })

    } else {
      console.log("No updates available, app is up to date.");
    }
  } catch (error) {
    console.error("Error checking for updates:", error);
  }
} 

export async function applyUpdate(version: BundleInfo): Promise<void> {
  const modalStore = useModalStore();

  try {
    let bundleId: BundleId = {
      id: version.id,
    };
    console.log("Applying update:", bundleId);
    await CapacitorUpdater.set(bundleId);
    console.log("Update applied successfully.");
    modalStore.closeModal();
  } catch (error) {
    console.error("Error applying update:", error);
  }
}
